const state = {
 siteUrl: "gfid" /* also known as aquaop feed */,
 // siteUrl: "ussec",
 // siteUrl: "ac"

 versionNumber: "v 4-01-2025.1",
 headerTitle: "",
 stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
 plan: {
  basic: {
   productTierId: "8f250426-d306-11eb-b249-26a539754a8b",
   monthly: { price: 199, stripePriceId: "price_1HpfQfDmA42O9qBDPwZ7OSVG" },
   yearly: { price: 1910, stripePriceId: "price_1HpfQgDmA42O9qBD6RlHNNGO" },
  },
  plus: {
   productTierId: "8f251146-d306-11eb-b249-26a539754a8b",
   monthly: { price: 399, stripePriceId: "price_1HqhRnDmA42O9qBDIHguHsRV" },
   yearly: { price: 3830, stripePriceId: "price_1HqhRoDmA42O9qBD7wKjuYVz" },
  },
  premium: {
   productTierId: "8f25129a-d306-11eb-b249-26a539754a8b",
   monthly: { price: 599, stripePriceId: "price_1IxHeXDmA42O9qBDdjHYwuEG" },
   yearly: { price: 5750, stripePriceId: "price_1IxHeXDmA42O9qBDmcasDkXp" },
  },
  enterprise: {
   productTierId: "8f25139e-d306-11eb-b249-26a539754a8b",
   monthly: { price: 999, stripePriceId: "price_1J4zgFDmA42O9qBDiRouYU0T" },
   yearly: { price: 9590, stripePriceId: "price_1J4zgFDmA42O9qBDjkKOGWNl" },
  },
 },
 ipAddress: {
  frontend: process.env.VUE_APP_AUTH0_CALLBACK_URL,
  backend: process.env.VUE_APP_AQUA_FEED_API_URL,

  /*authentication servers  */
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  realm: process.env.VUE_APP_AUTH0_REALM,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
 },

 agGridLicenseKey: process.env.VUE_APP_AG_GRID_LICENSE_KEY || null,
};

const mutations = {
 setHeaderTitle(state, title) {
  state.headerTitle = title;
 },
};

const actions = {
 setHeaderTitle(context, title) {
  context.commit("setHeaderTitle", title);
 },
};

const getters = {
 getSite(state) {
  return state.siteUrl;
 },
 getHeaderTitle(state) {
  return state.headerTitle;
 },
 getVersionNumber(state) {
  return state.versionNumber;
 },
 getPlan(state) {
  return state.plan;
 },
 getAppState(state) {
  return state.ipAddress;
 },
 getStripePublishableKey(state) {
  return state.stripePublishableKey;
 },
 getFrontendIpAddress(state) {
  return state.ipAddress.frontend;
 },
 getBackendIpAddress(state) {
  return state.ipAddress.backend;
 },
 getAuthenticationAudience(state) {
  return state.ipAddress.audience;
 },
 getAuthenticationRealm(state) {
  return state.ipAddress.realm;
 },
 getAuthenticationClientID(state) {
  return state.ipAddress.clientId;
 },
 getAgGridLicenseKey(state) {
  return state.agGridLicenseKey;
 },
};

export default {
 namespaced: false,
 state,
 mutations,
 actions,
 getters,
};
